import { Component, OnInit, ViewChild, ElementRef, ContentChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { CommonService } from 'src/app/core/helper/common.service';
import { DataStorage } from 'src/app/core/helper/data.storage';
import { LocalStorageService } from 'src/app/core/helper/local-storage.service';
import { PmdModalRef, PmdModalService, PmdSidebar } from 'src/app/shared/propeller';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @ViewChild(PmdSidebar) leftSidebar;
 
 
  titleObj: any = {};
  sideBarOverlay = false;

  public activated: {
    home: boolean;
  }

  // private router: Router;

  public childID: string;
  public id: string;
  public isLoading: boolean;

  private childParamSubscription: Subscription;
  private paramSubscription: Subscription;
  private timer: number;

  localMessage: any = {}

  isOpenc = true;
  currentYear = new Date().getFullYear();
  userDetails;
  modalRef: PmdModalRef;  
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private dataStorage: DataStorage,
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private modalService: PmdModalService,
    private layoutService: LayoutService
  ) {
    this.userDetails = this.localStorageService.getUser();

    this.dataStorage.dataStorageMessage.subscribe(message => {
      // console.log(message, "message");
      this.localMessage = { title: message['title'], subtitle: message['subtitle'] }
      this.localMessage = message
      // console.log(this.localMessage, "this.localMessage = message");
    });

    this.commonService.sideBarToggle.subscribe((data) => {
      console.log('-------------subscribe--------', this.leftSidebar);
      this.leftSidebar.toggleSideBar();
      this.sideBarOverlay = true;
    })

  }

  // languageForm: FormGroup;
  language = 'en';
  languages = [
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'fr', name: 'French' },
    { id: 'ar', name: 'Arabic' },
    { id: 'ru', name: 'Russian' }
  ];

  isOpenSidebar = true

  closeSidebar() {
    this.isOpenSidebar = false;
  }

  changeLang() {
    // console.log('===========change language======', this.language)
    this.commonService.changeLanguage(this.language)
  }

  openSidebar() {
    this.isOpenSidebar = true;
  }

  skipContentFocusAdd() {
    document.body.classList.add('skip-body-focus');
  }
  skipContentFocusRemove() {
    document.body.classList.remove('skip-body-focus');
  }

  public innerWidth: any;
  ngOnInit() {
    
    this.titleObj = this.activatedRoute.snapshot.firstChild.data;
    // console.log(this.titleObj, "this.titleObj");

  }



  stopPropogation(event) {
    event.stopPropagation();
  }

  redirectTo(path) {
    this.router.navigate([path]);
  }

  public isOpen: boolean;

  ngAfterViewInit() {

    // if (window.innerWidth < 1200) {
    //   document.getElementById('leftSidebarMenu').classList.remove('pmd-sidebar-left', 'pmd-sidebar-open', 'pmd-sidebar-slide-push');
    //   document.getElementById('leftSidebarMenu').classList.add('pmd-sidebar-left-fixed');

    //   document.querySelector('.pmd-sidebar-overlay').addEventListener('click', function() {
    //     document.getElementById('1Level').classList.remove('pmd-sidebar-open');
    //     document.getElementById('2Level').classList.remove('pmd-sidebar-open');
    //     document.querySelector('.sidebar-menu-group').remove();        
    //   });
    // }

  }

  test() {
    console.log('=========test')
  }

  toggleSideBar() {
    // this.leftSidebar.toggleSideBar();
    this.commonService.sideBarToggle.emit();
  }

/**
* show help popup
*/
  showHelpPopup() {
   this.layoutService.setHelpPopupFlag(true); 
  }

 
}
